import React from "react";
import { EyeIcon } from "../../../../../../../assets/Icons/EyeIcon";
import { EyeOffIcon } from "../../../../../../../assets/Icons/EyeOffIcon";
import styles from "./styles.module.scss";

export function PasswordVisibilityToggle({ isVisible, onToggle }) {
  return (
    <button onClick={onToggle} className={styles.root}>
      {isVisible ? <EyeIcon /> : <EyeOffIcon />}
    </button>
  );
}
